// todo: scroll listeners should be debounced
// toggle class when page is scrolled
const header = document.getElementById('header');

const setScrollingClass = () => {
  const isScrolling = window.scrollY > header.offsetTop;
  // add general scrolling class to the body
  document.body.classList.toggle('scrolling', isScrolling);
};

window.addEventListener('scroll', setScrollingClass);
